<div class="formula-modelo-card" [class.selected]="selecionado"
    role="button" tabindex="0"
    (click)="selecionar.emit()"
    (keydown.enter)="selecionar.emit()">

    @if (mostrarVigencia) {
    <div class="vigencia-header" [ngClass]="vigencia.classe">
        <mat-icon class="material-symbols-outlined vigencia-header-icon">{{ vigencia.icone }}</mat-icon>
        <span class="vigencia-header-texto">{{ vigencia.texto }}</span>
    </div>
    }

    <div class="formula-card-header">
        <div class="formula-tags">
            <span class="status-badge" [ngClass]="badgeClasses.modelo" style="font-size:0.75rem;">
                {{ rotuloModelo || ('Modelo ' + modelo.modelo) }}
            </span>
            @if (ehPadrao) {
            <span class="status-badge" [ngClass]="classePadrao" style="font-size:0.75rem;">
                {{ rotuloPadrao }}
            </span>
            }
        </div>
        @if (selecionado) {
        <mat-icon class="material-symbols-outlined card-check">check_circle</mat-icon>
        }
    </div>

    @if (modeloExibido.descricao) {
    <p class="formula-desc text-secondary">{{ modeloExibido.descricao }}</p>
    }

    <app-formula-expressao-section
        [expressao]="modeloExibido.expressao"
        [variaveis]="variaveis">
    </app-formula-expressao-section>

    @if (versoesOrdenadas.length > 1) {
    <footer class="formula-modelo-card-footer">
        <div class="versao-paginacao" aria-label="Navegar pelas versões do modelo">
            <button mat-icon-button type="button"
                [disabled]="!podeNavegarVersaoAnterior"
                [matTooltip]="podeNavegarVersaoAnterior ? 'Exibir versão anterior' : 'Não há versão anterior.'"
                (click)="navegarVersao($event, -1)" aria-label="Versão anterior">
                <mat-icon class="material-symbols-outlined">chevron_left</mat-icon>
            </button>
            <span>{{ indiceVersao + 1 }} de {{ versoesOrdenadas.length }}</span>
            <button mat-icon-button type="button"
                [disabled]="!podeNavegarProximaVersao"
                [matTooltip]="podeNavegarProximaVersao ? 'Exibir próxima versão' : 'Não há próxima versão.'"
                (click)="navegarVersao($event, 1)" aria-label="Próxima versão">
                <mat-icon class="material-symbols-outlined">chevron_right</mat-icon>
            </button>
        </div>
    </footer>
    }
</div>
